import { jsx as m } from "react/jsx-runtime";
import { Chip as r } from "@mui/material";
import { makeStyles as l } from "tss-react/mui";
import c from "./Tag.style.js";
const i = l()(c), p = ({
  className: s = "",
  dataTestid: t = "Lumi-tag",
  ...o
}) => {
  const { classes: a } = i(), e = `${a.chip} ${s}`;
  return /* @__PURE__ */ m(r, { className: e, "data-testid": t, ...o });
}, g = p;
export {
  p as Tag,
  g as default
};
